import { render, staticRenderFns } from "./pExpertCreateIndex.vue?vue&type=template&id=0d4fe2fe"
import script from "./pExpertCreateIndex.vue?vue&type=script&lang=js"
export * from "./pExpertCreateIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports